import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminMentorsIndex } from '@/types';
import { CreateMentorDialog } from './components/CreateMentorDialog';
import { MentorsTable } from './components/MentorsTable';

export default function Index({
  mentors,
  eventSlug,
  eventName,
  title,
}: AdminMentorsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Mentors</h1>
            <p className="text-muted-foreground">
              Manage hackathon mentors for {eventName}
            </p>
          </div>
          <CreateMentorDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Mentors ({mentors.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <MentorsTable eventSlug={eventSlug} mentors={mentors} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
